import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";


import Handlebars from 'handlebars';
import DOMPurify from 'dompurify';
import Parser from 'html-react-parser';
import DocumentView from "../../common/DocumentView";
import moment from "moment";
import { ThreeDots } from "react-loader-spinner";

import { getDocCopyByDocNo } from "../../services/api/docCopy";
import { getBuyerInvoiceById, getEWayBillById, getEWayBillDocument } from "../../services/api/buyerInvoice"
import { getBuyerInvoiceItems } from "../../services/api/buyerInvoiceItem";
import { getMaterialItemsDataByBuyerReqItemIds } from "../../services/api/buyerReqItem";

import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { getAdjustmentNoteById } from "../../services/api/adjustmentNotes";
import Menu from "../../helpers/Menu";
import { Button } from "../../helpers";
import downloadFile from "../../utils/DownloadFile";

const EwayBillDocument = () =>{
    const { ewayBillId } = useParams()

    const [isLoading, setIsLoading] = useState(true)

    const [eWayBill, setEWayBill] = useState({})
    const [eWayBillDocumentStr, setEWayBillDocumentStr] = useState()
    const [adjustmentNote, setAdjustmentNote] = useState({})
    const [adjustmentNoteItems, setAdjustmentNoteItems] = useState([])
    const [buyerInvoice, setBuyerInvoice] = useState(null)
    const [buyerInvoiceItems, setBuyerInvoiceItems] = useState([])
    const [materialDetails, setMaterialDetails] = useState([])
    const [pmCompanyBillAddrDetails, setPMCompanyBillAddrDetails] = useState({})
    const [buyerBillAddrDetails, setBuyerBillAddrDetails] = useState({})
    const [buyerShipAddrDetails, setBuyerShipAddrDetails] = useState({})
    const [ewayBillPDFURL, setEWayBillPDFURL] = useState(null)
    const [eWayBillDocumentHTML, setEWayBillDocumentHTML] = useState(null)

    const [isPDFLoading, setIsPDFLoading] = useState(false)

    const actionMenu = useRef(null)

    const dispatch = useDispatch()

    useEffect(() => {
        getEWayBill()
    }, [ewayBillId])

    const getEWayBill = async () => {
        if (ewayBillId){
            const ewayBillResponse = await getEWayBillById(ewayBillId)
            console.log("ewayBillResponse", ewayBillResponse)
            if (ewayBillResponse?.failure){
                return dispatch(raiseToast({severity:'error', summary: 'E-Way Bill', detail: ewayBillResponse?.data?.error, life: 3000}))
            }
            if (ewayBillResponse?.data?.adjustmentNoteId){
                const adjustmentNoteRes = await getAdjustmentNoteById(ewayBillResponse?.data?.adjustmentNoteId)
                if(adjustmentNoteRes.failure){
                    return dispatch(raiseToast({severity:'error', summary: 'Adjustment Note details', detail: adjustmentNoteRes.data.error, life: 3000}))
                }
                setAdjustmentNote(adjustmentNoteRes?.data?.adjustmentNotes)
                setAdjustmentNoteItems(adjustmentNoteRes?.data?.adjustmentNoteItems)

                const ewayBillPdfUrlRes = await getDocCopyByDocNo(ewayBillResponse?.data?.docNo)
                if(ewayBillPdfUrlRes?.failure){
                    return dispatch(raiseToast({severity:'error', summary: 'E-Way Bill pdf', detail: ewayBillPdfUrlRes.data.error, life: 3000}))
                }

                const ewayBillDocumentRes = await getEWayBillDocument()
                console.log("ewayBillDocumentRes", ewayBillDocumentRes)
                if(ewayBillDocumentRes?.failure){
                    return dispatch(raiseToast({severity:'error', summary: 'E-Way Bill Doc', detail: ewayBillDocumentRes.data.error, life: 3000}))
                }

                setEWayBill(ewayBillResponse?.data)
                setEWayBillPDFURL(ewayBillPdfUrlRes?.docLocation)
                setEWayBillDocumentStr(ewayBillDocumentRes?.data?.ewayBillDocument)
                // setEWayBillDocumentHTML(ewayBillDocumentRes?.data?.ewayBillDocument)
                getBuyerInvoice(adjustmentNoteRes?.data?.adjustmentNotes?.buyerInvoiceId)

            }
            if (ewayBillResponse?.data?.buyerInvoiceId){
                const buyerInvoiceResponse = await getBuyerInvoiceById(ewayBillResponse?.data?.buyerInvoiceId)
                console.log("buyerInvoiceResponse", buyerInvoiceResponse)
                if (buyerInvoiceResponse?.failure){
                    return dispatch(raiseToast({severity:'error', summary: 'Buyer Invoice', detail: buyerInvoiceResponse?.data?.error, life: 3000}))
                }

                const buyerInvoiceItemsResponse = await getBuyerInvoiceItems({ buyerInvoiceIds: [ewayBillResponse?.data?.buyerInvoiceId], paginator: false })
                console.log("buyerInvoiceItemsResponse===", buyerInvoiceItemsResponse,buyerInvoice)
                if(buyerInvoiceItemsResponse.failure){
                    setIsLoading(false)
                    return dispatch(raiseToast({severity:'error', summary: 'Error Message', detail: buyerInvoiceItemsResponse.data.error, life: 3000}))
                }

                let buyerReqItemsIds = buyerInvoiceItemsResponse?.data?.map(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerReqItemId)
                let materialItemsDataByBuyerReqItemIdsResponse
                if (buyerReqItemsIds?.length > 0){
                    materialItemsDataByBuyerReqItemIdsResponse = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds })
                    console.log("materialItemsDataByBuyerReqItemIdsResponse===", materialItemsDataByBuyerReqItemIdsResponse)
                }
        
                if(materialItemsDataByBuyerReqItemIdsResponse?.failure){
                    setIsLoading(false)
                    return dispatch(raiseToast({severity:'error', summary: 'Error Message', detail: materialItemsDataByBuyerReqItemIdsResponse.data.error, life: 3000}))
                }else{
                    setMaterialDetails(materialItemsDataByBuyerReqItemIdsResponse?.data)
                }

                const ewayBillPdfUrlRes = await getDocCopyByDocNo(ewayBillResponse?.data?.docNo)
                console.log("ewayBillPdfUrlRes", ewayBillPdfUrlRes)
                if(ewayBillPdfUrlRes?.failure){
                    return dispatch(raiseToast({severity:'error', summary: 'E-Way Bill pdf', detail: ewayBillPdfUrlRes.data.error, life: 3000}))
                }

                const ewayBillDocumentRes = await getEWayBillDocument()
                console.log("ewayBillDocumentRes", ewayBillDocumentRes)
                if(ewayBillDocumentRes?.failure){
                    return dispatch(raiseToast({severity:'error', summary: 'E-Way Bill Doc', detail: ewayBillDocumentRes.data.error, life: 3000}))
                }

                setEWayBill(ewayBillResponse?.data)
                setEWayBillPDFURL(ewayBillPdfUrlRes?.docLocation)
                setEWayBillDocumentStr(ewayBillDocumentRes?.data?.ewayBillDocument)
                // setEWayBillDocumentHTML(ewayBillDocumentRes?.data?.ewayBillDocument)
                setBuyerInvoice(buyerInvoiceResponse?.data?.buyerInvoice)
                setBuyerInvoiceItems(buyerInvoiceItemsResponse?.data)
                setPMCompanyBillAddrDetails(buyerInvoiceResponse?.data?.pmCompanyBillAddrDetails)
                setBuyerBillAddrDetails(buyerInvoiceResponse?.data?.buyerBillAddrDetails)
                setBuyerShipAddrDetails(buyerInvoiceResponse?.data?.buyerShipAddrDetails)
            }
            setIsLoading(false)
        }

    }

    const getEWayBillPDFUrl = async () => {
        const generateIfNotExists = true
        const docCopyRes = await getDocCopyByDocNo(eWayBill?.docNo, generateIfNotExists)
        if(docCopyRes.failure){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "E-Way Bill", detail:docCopyRes.data.error, life: 3000}))
        }
        
        if(!docCopyRes?.docLocation){
            setIsPDFLoading(false)
            return dispatch(raiseToast({severity:'error', summary: "E-Way Bill", detail: "E-Way Bill Document was not found.", life: 3000}))
        }

        downloadFile(docCopyRes.docLocation, "ewayBill.pdf")
        setIsPDFLoading(false)
    }

    const getBuyerInvoice = async (buyerInvoiceId) => {
        const buyerInvoiceResponse = await getBuyerInvoiceById(buyerInvoiceId)
            console.log("buyerInvoiceResponse", buyerInvoiceResponse)
            if (buyerInvoiceResponse?.failure){
                return dispatch(raiseToast({severity:'error', summary: 'Buyer Invoice', detail: buyerInvoiceResponse?.data?.error, life: 3000}))
            }

            const buyerInvoiceItemsResponse = await getBuyerInvoiceItems({ buyerInvoiceIds: [buyerInvoiceId], paginator: false })
            console.log("buyerInvoiceItemsResponse===", buyerInvoiceItemsResponse,buyerInvoice)
            if(buyerInvoiceItemsResponse.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Error Message', detail: buyerInvoiceItemsResponse.data.error, life: 3000}))
            }

            let buyerReqItemsIds = buyerInvoiceItemsResponse?.data?.map(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerReqItemId)
            let materialItemsDataByBuyerReqItemIdsResponse
            if (buyerReqItemsIds?.length > 0){
                materialItemsDataByBuyerReqItemIdsResponse = await getMaterialItemsDataByBuyerReqItemIds({ buyerReqItemsIds })
                console.log("materialItemsDataByBuyerReqItemIdsResponse===", materialItemsDataByBuyerReqItemIdsResponse)
            }
    
            if(materialItemsDataByBuyerReqItemIdsResponse?.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', summary: 'Error Message', detail: materialItemsDataByBuyerReqItemIdsResponse.data.error, life: 3000}))
            }else{
                setMaterialDetails(materialItemsDataByBuyerReqItemIdsResponse?.data)
            }

            setBuyerInvoice(buyerInvoiceResponse?.data?.buyerInvoice)
            setBuyerInvoiceItems(buyerInvoiceItemsResponse?.data)
            setPMCompanyBillAddrDetails(buyerInvoiceResponse?.data?.pmCompanyBillAddrDetails)
            setBuyerBillAddrDetails(buyerInvoiceResponse?.data?.buyerBillAddrDetails)
            setBuyerShipAddrDetails(buyerInvoiceResponse?.data?.buyerShipAddrDetails)
    }

    const renderHTMLEWayBillDocument = (documentHTML) => {
        // const { eWayBill, buyerInvoice, buyerInvoiceItems, pmCompanyBillAddrDetails, buyerBillAddrDetails, buyerShipAddrDetails } = documentData

        // const isSameState = buyerBillAddrDetails?.stateId === pmCompanyBillAddrDetails?.stateId ? true : false

        // let productsList = []
        // console.log("buyer", buyerInvoice, isSameState)
        // buyerInvoiceItems.map((eachBuyerInvoiceItem, index)=>{
        //     const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === eachBuyerInvoiceItem?.materialId)
        //     let product = {
        //         "productName":relatedMaterial?.companyProdName ? relatedMaterial?.companyProdName : relatedMaterial?.productName,
        //         "productDesc":relatedMaterial?.companyProdSpec ? relatedMaterial?.companyProdSpec : relatedMaterial?.productSpecification,
        //         "hsnCode":eachBuyerInvoiceItem?.HSNCode?.toString().substring(0,4),
        //         "quantity":eachBuyerInvoiceItem.qty,
        //         "qtyUnit":relatedMaterial?.UOM,
        //         "cgstRate":!isSameState ? (eachBuyerInvoiceItem?.GSTRate / 2) : 0,
        //         "sgstRate":!isSameState ? (eachBuyerInvoiceItem?.GSTRate / 2) : 0,
        //         "igstRate":isSameState ? eachBuyerInvoiceItem.GSTRate : 0,
        //         "cessRate":0,
        //         "cessNonAdvol":0,
        //         "taxableAmount":eachBuyerInvoiceItem.GSTRate * eachBuyerInvoiceItem.unitPrice * 0.01
        //     }
        //     productsList.push(product)
        // })


        // let eWayBillObject = {
        //     "supplyType":"O",
        //     "subSupplyType":"1",
        //     "subSupplyDesc":"",
        //     "docNo":"35237842",
        //     "docType":"INV",
        //     "docDate":moment(buyerInvoice?.createdAt).format("DD/MM/YYYY"),
        //     "fromGstin":"34AACCC1596Q002",
        //     "fromTrdName":pmCompanyBillAddrDetails.companyName,
        //     "fromAddr1":pmCompanyBillAddrDetails.billAddress,
        //     "fromAddr2":pmCompanyBillAddrDetails.city,
        //     "fromPlace":pmCompanyBillAddrDetails.stateName,
        //     "fromPincode":pmCompanyBillAddrDetails.pinCode,
        //     "actFromStateCode":pmCompanyBillAddrDetails.stateId,
        //     "fromStateCode":pmCompanyBillAddrDetails.stateId,
        //     "toGstin":buyerBillAddrDetails.gstinCode,
        //     "toTrdName":buyerBillAddrDetails.companyName,
        //     "toAddr1":buyerShipAddrDetails.shipAddr,
        //     "toAddr2":buyerShipAddrDetails.city,
        //     "toPlace":buyerShipAddrDetails.stateName,
        //     "toPincode":buyerShipAddrDetails.pinCode,
        //     "actToStateCode":buyerShipAddrDetails.stateId,
        //     "toStateCode":buyerShipAddrDetails.stateId,
        //     "transactionType":2,
        //     "dispatchFromGSTIN":pmCompanyBillAddrDetails.gstinCode,
        //     "dispatchFromTradeName":pmCompanyBillAddrDetails.companyName,
        //     "shipToGSTIN":"",
        //     "shipToTradeName":buyerBillAddrDetails.companyName,
        //     "otherValue":0,
        //     "totalValue":buyerInvoice?.totalAmountBeforeTax,
        //     "cgstValue":!isSameState ? (buyerInvoice?.totalInvTax/ 2) : 0,
        //     "sgstValue":!isSameState ? (buyerInvoice?.totalInvTax/ 2) : 0,
        //     "igstValue":isSameState ? (buyerInvoice?.totalInvTax) : 0,
        //     "cessValue":0,
        //     "cessNonAdvolValue":0,
        //     "totInvValue":buyerInvoice?.totalAmountWithTax,
        //     "transporterId":"",
        //     "transporterName":"",
        //     "transDocNo":"",
        //     "transMode":"1",
        //     "transDistance":"0",
        //     "transDocDate":"",
        //     "vehicleNo":"KA01AB1234",
        //     "vehicleType":"R",
        //     "itemList":productsList
        // }
        // eWayBillObject = {...eWayBillObject, ...eWayBill}

        // let productName = ''
        // if(eWayBillObject.itemList){
        //     let itemlistLength = eWayBillObject.itemList.length
        //     let lastItem = eWayBillObject.itemList[itemlistLength - 1]
        //     productName = lastItem.hsnCode +" - "+ lastItem.productDesc
        //     if(itemlistLength>1){
        //         productName = productName + " (+" +(itemlistLength-1) +")"
        //     }
        // }
        // eWayBillObject = {...eWayBillObject, productName : productName}

        // if(eWayBillObject.transactionType){
        //     if(eWayBillObject.transactionType == "1"){
        //         eWayBillObject.transactionType = "Regular"
        //     }
        //     else if(eWayBillObject.transactionType == "2"){
        //         eWayBillObject.transactionType = "Bill To - Ship To"
        //     }
        //     else if(eWayBillObject.transactionType == "3"){
        //         eWayBillObject.transactionType = "Bill From - Dispatch From"
        //     }
        //     else if(eWayBillObject.transactionType == "4"){
        //         eWayBillObject.transactionType = "Combination of 2 and 3"
        //     }
        // }

        // if(eWayBillObject.supplyType == "I"){
        //     eWayBillObject.supplyType = "Inward - Supply"
        // }else{
        //     eWayBillObject.supplyType = "Outward - Supply"
        // }

        // let transporter = eWayBillObject.transporterId
        // if(eWayBillObject.transporterName){
        //     transporter = transporter + " & "+ eWayBillObject.transporterName
        //     eWayBillObject = {...eWayBillObject, transporter : transporter}
        // }

        // if (eWayBillObject.transMode) {
        //     if (eWayBillObject.transMode == '1') {
        //         eWayBillObject = {...eWayBillObject, transportationMode : 'Road'}
        //     }
        //     else if(eWayBillObject.transMode == '2'){
        //         eWayBillObject = {...eWayBillObject, transportationMode : 'Rail'}
        //     }
        //     else if(eWayBillObject.transMode == '3'){
        //         eWayBillObject = {...eWayBillObject, transportationMode : 'Air'}
        //     }
        //     else if(eWayBillObject.transMode == '4'){
        //         eWayBillObject = {...eWayBillObject, transportationMode : 'Ship'}
        //     }
        // }

        // const ewayBillDocumentTemplate = Handlebars.compile(eWayBillDocumentStr)
        // const documentHTML = ewayBillDocumentTemplate({ 
        //    eWayBillObject
        // })

        const sanitizedHTML = DOMPurify.sanitize(documentHTML)
        console.log("documentHTML", documentHTML)
        return(
            <>
                {Parser(sanitizedHTML)}
            </>
        )
    }


    const renderEWayBillPDF = (ewayBillPDFURL) => {
        console.log("pdf trigger", ewayBillPDFURL)
        return(
            <div className="" style={{width: '210mm'}}>
                <DocumentView fileUrl={ewayBillPDFURL} />
            </div>
        )
    }

    const actionMenuItems = [
        {
            label: isPDFLoading ? "Loading..."  : "Download E-Way Bill",
            command: () => {
                if(!ewayBillPDFURL){
                    let fileName =  "ewayBill.pdf"
                    downloadFile(ewayBillPDFURL, fileName)
                }
                else{
                    setIsPDFLoading(true)
                    getEWayBillPDFUrl()
                }
            }
        },
    ]



    return(
        <div className="pb-3 document-page document-page-height">
            <div className="mb-0 document-page-container">
                <div className="flex flex-column md:flex-row md:justify-content-between">
                    <h4 className="mt-2 mb-0">E-WAY BILL  {eWayBill?.ewayBillNo && ` | ${eWayBill?.ewayBillNo}`}</h4>
                    <div className="flex justify-content-end">
                        <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                        <Button className="h-2rem  mb-2 p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    </div>
                </div>
            </div>

            {isLoading ? (
                <div className="flex justify-content-center align-items-center ">
                    <ThreeDots height="50" width="50" radius="5" color="#00baac" ariaLabel="three-dots-loading" visible={true} />
                </div>
                ) : (ewayBillPDFURL ? renderEWayBillPDF(ewayBillPDFURL) : renderHTMLEWayBillDocument(eWayBillDocumentHTML)) 
            }
        </div>
    )
}

export default EwayBillDocument;